// Drop nav links flagged hide_from_main_navigation. Breadcrumb intentionally
// does NOT use this — hidden pages must still appear in the breadcrumb trail.
// Generic over the link shape so it works for both INavigationLink and the
// inline link objects nested inside IHeader's navigation levels.
export const visibleNavLinks = <T extends { hide_from_main_navigation?: boolean }>(
  links: T[] | undefined
): T[] => links?.filter((link) => !link?.hide_from_main_navigation) ?? [];

// Drop L1 nav items authored without a title: they render as empty, unnamed
// trigger buttons (WCAG 4.1.2) and empty pills in the nav bar.
export const visibleNavLevelOne = <T extends { nav_level_one_title?: string }>(
  items: T[] | undefined
): T[] => items?.filter((item) => !!item?.nav_level_one_title?.trim()) ?? [];
